import { ApiChartService } from "@/infrastructure/services/ApiChartService";
import { logger } from "@/infrastructure/services/LoggerService";
export class ChartUseCases {
    constructor(chartService) {
        Object.defineProperty(this, "chartService", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Use API service by default
        this.chartService = chartService || new ApiChartService();
    }
    /**
     * Load all charts for the dashboard
     * @returns ChartsResult containing sorted charts array and hasData flag
     */
    async loadCharts() {
        try {
            logger.debug("Loading charts...");
            const result = await this.chartService.getCharts();
            logger.debug(`Loaded ${result.charts.length} charts, hasData: ${result.hasData}`);
            return {
                charts: result.charts.sort((a, b) => a.order - b.order),
                hasData: result.hasData,
            };
        }
        catch (error) {
            logger.debug("Failed to load charts:", error);
            // Re-throw the error to let the component handle it locally
            // This preserves the dashboard layout with menu instead of redirecting to /error page
            throw error;
        }
    }
    /**
     * Initialize Toucan widget for a specific chart
     */
    async initializeToucanWidget(containerId, embedId, token, lang, forceReload = false) {
        try {
            await this.chartService.loadToucanScript(containerId, embedId, token, lang, forceReload);
        }
        catch (error) {
            logger.debug(`Failed to load Toucan widget ${embedId}:`, error);
            // Don't throw - allow other widgets to load
        }
    }
    /**
     * Cleanup all chart resources
     */
    cleanup() {
        try {
            this.chartService.cleanup();
        }
        catch (error) {
            logger.debug("Error during chart cleanup:", error);
        }
    }
}
